export default "__VITE_ASSET__5e5f1876__"